import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';

import { experimentalConfigSelectors } from '.';

export const selectExperimentalConfig = (state: RootState) =>
  state.experimentalConfig;

export const selectExperimentalConfigByIds = createDraftSafeSelector(
  [selectExperimentalConfig, (_state: RootState, ids: string[]) => ids],
  ({ experimentalConfigs }, ids) => {
    return ids.map((id: string) =>
      experimentalConfigSelectors.selectById(experimentalConfigs, id),
    );
  },
);
